module.exports = __webpack_public_path__ + "img/eye.e0766df2.svg";